module.exports = __webpack_public_path__ + "img/lqh.81194020.jpg";